const merge = require("lodash/merge");
const defaults = require("./lib/module/defaults");

// Providers
import googleProvider from "./lib/providers/google.js";

// Schemes
import localScheme from "./lib/schemes/local.js";
import oidcScheme from "./lib/schemes/oidc.js";

import Auth from "./lib/core/auth";

const authProviderMapping = {
  google: googleProvider
};

const authSchemeMapping = {
  local: localScheme,
  oidc: oidcScheme
};

// oidc class set to windows for checking it in check session iframe
window.oidcSchemeClass = oidcScheme;

function validateOptions(options) {
  if (options.endpoints) {
    // eslint-disable-next-line no-console
    console.error(
      "`auth.endpoints` has been moved into `auth.strategies.local`."
    );
    options.strategies.local = merge({}, options.strategies.local, {
      endpoints: options.endpoints
    });
    delete options.endpoints;
  }
}

function processStrategies(options) {
  const strategies = [];
  const strategyScheme = new Map();

  for (const name in options.strategies) {
    if (!options.strategies[name]) {
      continue;
    }

    // Clone strategy
    const strategy = Object.assign({}, options.strategies[name]);

    // Guess _name property
    if (!strategy._name) {
      strategy._name = name;
    }

    // Guess _provider property
    if (!strategy._provider) {
      strategy._provider = strategy._name;
    }
    // Try to apply provider
    const provider = resolveProvider.call(this, strategy._provider);

    if (typeof provider === "function") {
      provider.call(this, strategy, { name });
    }

    // Guess _scheme property
    if (!strategy._scheme) {
      strategy._scheme = strategy._name;
    }

    // Resolve and copy scheme
    const schemeSrc = resolveScheme.call(this, strategy._scheme);

    if (!schemeSrc) {
      // Scheme is mandatory but is invalid
      continue;
    }

    // Remove unnecessary fields
    delete strategy._scheme;
    delete strategy._provider;

    strategyScheme.set(
      strategy,
      //   "." + join("/", "schemes", basename(schemeSrc))
      schemeSrc
    );
    strategies.push(strategy);
  }

  return {
    strategies,
    strategyScheme
  };
}

function resolveProvider(provider) {
  if (typeof provider === "function") {
    return provider;
  }

  if (typeof provider !== "string") {
    return;
  }

  let resolvedProvider = authProviderMapping[provider];

  if (resolvedProvider) {
    return resolvedProvider;
  } else {
    console.error( //eslint-disable-line
      `${provider} provider not installed. Add ${provider} to auth module`
    );
  }
}

function resolveScheme(scheme) {
  if (typeof scheme !== "string") {
    return;
  }

  if (authSchemeMapping[scheme]) {
    return scheme;
  } else {
    console.error( //eslint-disable-line
      `${scheme} scheme not installed. Add ${scheme} to auth module`
    );
  }
}

export default function(authOptions, ctx) {
  // Merge all option sources
  const options = merge({}, defaults, authOptions);

  // Validate and Normalize options
  validateOptions.call(this, options);

  // Copy all core templates
  // copyCore.call(this, options);

  // Process and normalize strategies
  const { strategies, strategyScheme } = processStrategies.call(this, options);
  delete options.strategies;

  // Set defaultStrategy
  const strategyNames = strategies.map(x => x._name);
  options.defaultStrategy = options.defaultStrategy || strategyNames[0];

  if (!options.defaultStrategy) {
      console.warn("no strategy defined!"); // eslint-disable-line
  } else if (strategyNames.indexOf(options.defaultStrategy) === -1) {
      console.warn(`strategy ${options.defaultStrategy} is not defined!`); // eslint-disable-line
  }

  const $auth = new Auth(ctx, options);

  for (let index in strategies) {
    const name = strategies[index]._name;
    const scheme = authSchemeMapping[strategyScheme.get(strategies[index])];
    $auth.registerStrategy(name, new scheme($auth, strategies[index]));
  }

  return $auth;
}
